import {
    BOOLEAN,
    DROPDOWN_STRING,
    MULTILINK,
    OPTIONAL_TEXT,
    OPTIONAL_TEXT_3000,
    REQUIRED_STRING,
    YEAR,
} from '@/components/Form/schema';
import { uniqueNameShortField } from '@/forms/forms';
import {
    GetExternalEventEventByNameShortDocument,
    GetExternalEventSeriesByNameShortDocument,
} from '@/generated/graphql';
import { z } from 'zod';

const EXTERNAL_EVENT_SERIES_NAME_SHORT_FIELD = uniqueNameShortField(GetExternalEventSeriesByNameShortDocument);

export const ExternalEventSeriesCreateSchema = z.object({
    nameShort: EXTERNAL_EVENT_SERIES_NAME_SHORT_FIELD,
    nameLong: REQUIRED_STRING,
    category: DROPDOWN_STRING,
    national: BOOLEAN,
});
export type ExternalEventSeriesCreateSchemaType = z.infer<typeof ExternalEventSeriesCreateSchema>;

export function getExternalEventSeriesUpdateSchema(id: string) {
    return z.object({
        nameShort: uniqueNameShortField(GetExternalEventSeriesByNameShortDocument, id),
        nameLong: REQUIRED_STRING,
        notes: OPTIONAL_TEXT_3000,
        description: OPTIONAL_TEXT_3000,
        explanation: OPTIONAL_TEXT_3000,
        category: DROPDOWN_STRING,
        national: BOOLEAN,
        silent: BOOLEAN,
        websites: MULTILINK,
    });
}
export type ExternalEventSeriesUpdateSchemaType = z.infer<ReturnType<typeof getExternalEventSeriesUpdateSchema>>;

export const ExternalEventEventCreateSchema = z.object({
    nameShort: uniqueNameShortField(GetExternalEventEventByNameShortDocument),
    nameLong: REQUIRED_STRING,
    year: YEAR,
});

export type ExternalEventEventCreateSchemaType = z.infer<typeof ExternalEventEventCreateSchema>;

export function getExternalEventEventUpdateSchema(id: string) {
    return z.object({
        nameShort: uniqueNameShortField(GetExternalEventEventByNameShortDocument, id),
        nameLong: REQUIRED_STRING,
        year: YEAR,
        description: OPTIONAL_TEXT_3000,
        contact: OPTIONAL_TEXT,
        links: MULTILINK,
    });
}

export type ExternalEventEventUpdateSchemaType = z.infer<ReturnType<typeof getExternalEventEventUpdateSchema>>;
